import type { SVGProps } from "react";

/**
 * Voice-agent glyph for the "Asistentes de Voz IA" nav item.
 * The robot is the exact lucide `Bot` (same as "Automatizaciones") so both
 * read consistently — it inherits the text color via currentColor. The green
 * phone badge is the only voice-specific cue.
 */
export function VoiceAgentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Robot — identical to the lucide Bot used for Automatizaciones */}
      <path d="M12 8V4H8" />
      <rect width="16" height="12" x="4" y="8" rx="2" />
      <path d="M2 14h2" />
      <path d="M20 14h2" />
      <path d="M15 13v2" />
      <path d="M9 13v2" />
      {/* Voice cue: green phone handset in the bottom-right corner */}
      <path
        d="M15.7 15c-.34 0-.6.28-.6.62a6.5 6.5 0 0 0 6.48 6.48c.34 0 .62-.26.62-.6v-1.7c0-.3-.22-.55-.52-.6a5.6 5.6 0 0 1-1.46-.42.6.6 0 0 0-.65.14l-.63.63a5.4 5.4 0 0 1-2.4-2.4l.63-.63a.6.6 0 0 0 .14-.65 5.6 5.6 0 0 1-.42-1.46.6.6 0 0 0-.6-.52z"
        fill="#1FC16B"
        stroke="none"
      />
    </svg>
  );
}
